(async() => {
  let pageModeContent = document.getElementById('pageModeContent')
  pageModeContent.addEventListener('click', e => {
    e.stopPropagation();
  })
  let landingPageModel = document.getElementById('landingPageModel')
  let displayDelay = Number(landingPageModel.getAttribute('display-delay') || 1)
  let daysToReAppear = Number(landingPageModel.getAttribute('days-to-re-appear') || 1)
  const dayTimeNum = 1000 * 3600 * 24 * daysToReAppear
  let nowDateTime = new Date().getTime()
  let urlStr = window.location.href.indexOf('/pages/sign-up-now-for-a-chance-to-win-prizes') === -1
  const showModel = () => {
    let lastShowTime = window.localStorage.getItem('landingModel')
    if (urlStr && (!lastShowTime || nowDateTime - Number(lastShowTime) > dayTimeNum)) {
      landingPageModel.style.display = 'block'
      setTimeout(() => {
        // document.documentElement.style.overflow = 'hidden'
        landingPageModel.style.opacity = '1'
      }, displayDelay * 1000)
    }
  }
  document.getElementById('page_mode_close').addEventListener('click', e => {
    landingPageModel.style.opacity = '0'
    document.documentElement.style.overflow = 'auto'
    window.localStorage.setItem('landingModel', nowDateTime)
    setTimeout(() => {
      landingPageModel.style.display = 'none'
    }, displayDelay * 1000)
  })
  showModel()
})();